import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import SpotlightCard from "../SpotlightCard";
import MetaText from "../MetaText";
import GlobalHeadline from "../../GlobalHeadline";
import { formatBlogCardDate } from "../../../utils/siteUtils";

/**
 * Shared blog summary card.
 * Translation: Shared blog summary card.
 *
 * @param {Object} props - Blog card props.
 * @returns {JSX.Element} Blog card.
 */
const BlogCard = ({ post, readLabel = "Read Article" }) => (
  <SpotlightCard className="glass-panel blog-card">
    <MetaText className="blog-card__date">{formatBlogCardDate(post.publishedAt)}</MetaText>
    <GlobalHeadline as="h3">
      <Link to={`/blog/${post.slug}`} title={`Read: ${post.title}`}>
        {post.title}
      </Link>
    </GlobalHeadline>
    <p>{post.metaDescription}</p>
    <Link
      to={`/blog/${post.slug}`}
      className="inline-link blog-card__link"
      title={`Read "${post.title}"`}
      aria-label={`${readLabel}: ${post.title}`}
    >
      <span>{readLabel}</span>
      <ArrowRight size={16} />
    </Link>
  </SpotlightCard>
);

export default BlogCard;
